module.exports = __webpack_public_path__ + "static/media/splashVideo.0687105d.mp4";